// extracted by mini-css-extract-plugin
export default {"wrapper":"cardListProjects_wrapper__7K+MN","remove":"cardListProjects_remove__3kabi","removeIcon":"cardListProjects_removeIcon__ABF4B","list":"cardListProjects_list__4qmV5"};